module.exports = require('./helpers/bundle-url').getBundleURL('3dwVf') + "logo-dark.eefe0b7f.svg";